export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'hkG7suArPg4jFzgqbfxaQEa0h28AV6v2',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'hkG7suArPg4jFzgqbfxaQEa0h28AV6v2',
        audience: 'https://crew-time/api',
    }
}